import React from 'react';
import { ReactComponent as EditIconBase } from './Edit.svg';

export const EditIcon = (props: any) => (
  <EditIconBase {...props} style={{ transform: 'scale(2)' }} />
);

export default EditIcon;
